// @flow
import { combineActions, handleActions } from 'redux-actions';

import { getAccounts } from 'data/accounts/actions';
import { upsertResource, upsertResources, upsertResourceSetupUndo, completeWithError, resetResources } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './actions';
import { mkGoalsStore } from './types';
import {getGoals} from "./actions";

const goalsReducer = handleActions({
  [actions.createGoal]: (state) => state.set( 'isLoading', true),
  [actions.createGoalSuccess]:
    (state, action) => {
      const newState = upsertResourceSetupUndo(state, action, actions.deleteGoal);
      // todo: Remove when QCS has subscriber event system in-place
      // After creating a goal, we need to reload accounts (QCS will create a goal account for the Goal)
      const { asyncDispatch } = action;
      asyncDispatch(getGoals());
      // call twice to ensure that the goal account id has resolved
      setTimeout(() => {
        asyncDispatch(getAccounts());
        asyncDispatch(actions.getGoals());
        state.set('isLoading', false);
      }, 1000);
      return newState;
    },

  [actions.updateGoal]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.updateGoal),
  [actions.updateGoalSuccess]:
    (state, { payload: goal }) => upsertResource(state, goal),

  [actions.deleteGoal]:
    (state, action) => upsertResourceSetupUndo(state, action, actions.createGoal),
  [actions.deleteGoalSuccess]:
    (state, { payload: goal }) => upsertResource(state, goal),

  [actions.getGoals]:
    (state) => state.set( 'isLoading', true),
  [actions.getGoalsSuccess]:
    (state, { payload: data }) => upsertResources(state, data),
  [actions.getGoalsFailure]:
    (state, { payload: error }) => completeWithError(state, error),

  [combineActions(
    actions.createGoalFailure,
    actions.updateGoalFailure,
    actions.deleteGoalFailure,
  )]: (state, {payload: error, asyncDispatch}) => {
    asyncDispatch(actions.getGoals());
    return resetResources(state, error);
  },

}, mkGoalsStore());

export const REDUCER_KEY = 'goalStore';
export default goalsReducer;
